//Desenvolvido com base no artigo: https://vuejs.org/v2/guide/state-management.html#Simple-State-Management-from-Scratch
// Baseado em: https://github.com/coreui/coreui-vue/blob/master/src/components/Aside/AsideToggler.vue

import { asideMenuCssClasses } from '@/shared/classes'
import toggleClasses from '@/shared/toggle-classes'

export default {
    debug: false,
    state: {
        asideComponent: null,
        asideProps: null,
        onCloseCallback: () => {},
    },
    open(component, props = {}, onCloseCallback = () => {}) {
        this.setState(component, props, onCloseCallback)
        toggleClasses('aside-menu-show', asideMenuCssClasses, true)
    },
    setState(component, props, onCloseCallback) {
        this.state.asideComponent = component
        this.state.asideProps = props
        this.state.onCloseCallback = onCloseCallback
    },
    close(result, forceClear = true) {
        this.state.onCloseCallback(result)
        toggleClasses('aside-menu-show', asideMenuCssClasses)
        if (forceClear) {
            this.clearState()
        }
    },
    clearState() {
        setTimeout(() => {
            this.state.asideComponent = null
            this.state.asideProps = null
            this.state.onCloseCallback = () => {}
        }, 200)
    },
    updateProps(newProps) {
        this.state.asideProps = newProps
    },
}
